var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumberTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_704_2572)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 19,
    height: 18,
    rx: 8,
    fill: "#5062F0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9055 19.62C20.0655 19.62 20.1915 19.666 20.2835 19.758C20.3795 19.846 20.4275 19.964 20.4275 20.112V21H14.4755V20.508C14.4755 20.408 14.4955 20.304 14.5355 20.196C14.5795 20.084 14.6475 19.984 14.7395 19.896L17.3735 17.256C17.5935 17.032 17.7895 16.818 17.9615 16.614C18.1375 16.41 18.2835 16.208 18.3995 16.008C18.5155 15.808 18.6035 15.606 18.6635 15.402C18.7275 15.194 18.7595 14.976 18.7595 14.748C18.7595 14.54 18.7295 14.358 18.6695 14.202C18.6095 14.042 18.5235 13.908 18.4115 13.8C18.3035 13.692 18.1715 13.612 18.0155 13.56C17.8635 13.504 17.6915 13.476 17.4995 13.476C17.3235 13.476 17.1595 13.502 17.0075 13.554C16.8595 13.602 16.7275 13.672 16.6115 13.764C16.4955 13.852 16.3975 13.956 16.3175 14.076C16.2375 14.196 16.1775 14.328 16.1375 14.472C16.0695 14.656 15.9815 14.778 15.8735 14.838C15.7655 14.898 15.6095 14.912 15.4055 14.88L14.6255 14.742C14.6855 14.326 14.8015 13.962 14.9735 13.65C15.1455 13.334 15.3595 13.072 15.6155 12.864C15.8755 12.652 16.1715 12.494 16.5035 12.39C16.8395 12.282 17.1995 12.228 17.5835 12.228C17.9835 12.228 18.3495 12.288 18.6815 12.408C19.0135 12.524 19.2975 12.69 19.5335 12.906C19.7695 13.122 19.9535 13.382 20.0855 13.686C20.2175 13.99 20.2835 14.328 20.2835 14.7C20.2835 15.02 20.2355 15.316 20.1395 15.588C20.0475 15.86 19.9215 16.12 19.7615 16.368C19.6055 16.616 19.4215 16.856 19.2095 17.088C18.9975 17.32 18.7755 17.556 18.5435 17.796L16.5875 19.794C16.7755 19.738 16.9615 19.696 17.1455 19.668C17.3335 19.636 17.5115 19.62 17.6795 19.62H19.9055Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_704_2572",
    x: 0,
    y: 0,
    width: 35,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0156863 0 0 0 0 0.0235294 0 0 0 0 0.101961 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_704_2572"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_704_2572",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberTwo);
export default __webpack_public_path__ + "static/media/numberTwo.a75dc1027cb0d6bb4fcead151027c201.svg";
export { ForwardRef as ReactComponent };